<template>
    <main>
        <v-container class="grey lighten-4 fill-height" fluid>
        <v-row>
            <v-col cols="12" sm="8" md="4" class="mx-auto" >
                    <v-card class="elevation-12 ma-3">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Ändra lösenord</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                        <v-form ref="form">
                <v-text-field
                    type="password"
                    v-model="current_pass"
                    @click="current_pass = ''"
                    label="Nuvarande lösenord"
                    :rules="passRules"
                    outlined
                />
                <v-text-field
                    type="password"
                    v-model="password"
                    label="Lösenord"
                    :rules="passRules"
                    outlined
                />
                <v-text-field
                    type="password"
                    v-model="cnf_pass"
                    :rules="[v => v === password || 'Lösenorden matchar inte']"
                    label="Bekräfta lösenord"
                    outlined
                />
                <v-btn @click="submit" block text style="background-color:#ffa500">Submit <v-icon style="margin-left:2px;font-size:13px">fas fa-arrow-right</v-icon></v-btn>
            <v-alert type="success" v-show="alert" dismissible>
            Lösenordet ändrat.
            </v-alert>
            </v-form>
                </v-card-text>
            </v-card>
            </v-col>
        </v-row>
        </v-container>
    </main>
</template>

<script>
import store from "../../store";
export default {
    data: () => ({
        current_pass: "********",
        password: "",
        cnf_pass: "",
        alert: false,
        store: store,
        passRules: [
            v => !!v || "lösenord krävs",
            v => v.length >= 8 || "Lösenordet måste vara större än 8 tecken"
        ]
    }),
    created:function(){
        // if(this.store.state.user.role == 'user') this.$router.replace('/dashboard')
    },
    methods: {
        submit: async function() {
            if (this.$refs.form.validate()) {
                let bodyFormData = new FormData();
                bodyFormData.append("current_pass", this.current_pass);
                bodyFormData.append("password", this.password);
                bodyFormData.append("cnf_pass", this.cnf_pass);
                bodyFormData.append("userid", this.store.state.user.id);
                let config = {
                    method: "post",
                    url: "",
                    headers: {
                        "Content-Type": "application/form-data;charset=utf-8",
                        "Access-Control-Allow-Origin": "*",
                        Accept: "*/*"
                    },
                    data: bodyFormData
                };
                try {
                    await this.store.dispatch("Passwordchange", config);
                    this.store.state.loading = false;
                    this.alert = true;
                    //this.$router.replace("/admin/dashboard");
                }catch(err){
                    console.log()
                }
            }
        }
    }
};
</script>

<style></style>
